import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductsTopComponent } from './products-top/products-top.component';
import { PygOfferingComponent } from './pyg-offering/pyg-offering.component';
import { SubscribeComponent } from '../subscribe/subscribe.component';
import { TryDemoComponent } from '../try-demo/try-demo.component';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  imports: [
    ProductsTopComponent,
    PygOfferingComponent,
    SubscribeComponent,
    TryDemoComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsComponent {}
